import { createSimpleFunctional } from '@/util'

export const VCardAvatar = createSimpleFunctional('v-card-avatar')
